import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL';
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WTPPlantNameDDL } from '../../../../../Components/CommonDDL/WTPPlantNameDDL';
import { WTPSumpNumberPostDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPSidebarSlice/SumpNumberSlice';


export default function WTPSumpNumberMasterPagePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [SumpNumber, setSumpNumber] = useState(Flag === 'Update' ? rowData.sumpNumber : '')

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : '0',
        Label: Flag === 'Update' ? rowData.wardName : '0',
    })

    const [PlantName, setPlantName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_wtP_PlantID : '0' ,
        Label: Flag === 'Update' ? rowData.plantName : '0',
    })

    const handlePost = () => {
        const data = {
            M_WTP_SumpID: Flag === 'Update' ? rowData.m_wtP_SumpID : '0',
            M_WTP_PlantID: PlantName.ID,
            SumpNumber:SumpNumber,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(WTPSumpNumberPostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Sump Number Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">

                                <div className="col-lg-6 col-md-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        HWard={HWard}
                                        WLable={WLable}
                                        // rowData={rowData}
                                        // Flag={Flag}
                                    // Flag='ward'
                                    />

                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <WTPPlantNameDDL
                                        PlantName={PlantName}
                                        setPlantName={setPlantName}
                                        WardName={WardName}
                                        rowData={rowData}
                                        Flag={Flag}
                                    // Flag='ward'
                                    />

                                </div>

                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Sump Number </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="SumpNumber"
                                            value={SumpNumber}
                                            onChange={(e) => setSumpNumber(e.target.value)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                    onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}